module.exports = {
    routes: [
        {
            path: '/hvad-tilbyder-vi/',
            name: 'skills.groups-overview',
            component: require('./pages/GroupsOverview').default,
        },
        {
            path: '/hvad-tilbyder-vi/:group/',
            name: 'skills.group',
            component: require('./pages/Group').default,
        },
        {
            path: '/hvad-tilbyder-vi/:group/:skill',
            name: 'skills.skill',
            component: require('./pages/Skill').default,
        },
    ],
};



// WEBPACK FOOTER //
// ./src/taskflex/skills/routes.js